import {
  Directive,
  effect,
  Input,
  input,
  InputSignal,
  signal,
  TemplateRef,
  ViewContainerRef,
  WritableSignal,
} from '@angular/core';
import { Role } from '@core/constants';
import { ProfileApi } from '@core/services/api/profile.api';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AuthApi } from '@core/services/api/auth.api';

@UntilDestroy()
@Directive({
  selector: '[napaCanRender]',
  standalone: true,
})
export class CanRenderDirective {
  roles: InputSignal<Role[]> = input.required({ alias: 'napaCanRender' });
  private _condition: WritableSignal<boolean | undefined> = signal(undefined);

  @Input() set napaCanRenderAddCondition(value: boolean) {
    this._condition.set(value);
  }

  constructor(
    private templateRef: TemplateRef<never>,
    private viewContainer: ViewContainerRef,
    private profileApi: ProfileApi,
    private authApi: AuthApi
  ) {
    this.checkRenderCondition();
  }

  get isAdditionalConditionSet() {
    return typeof this._condition() !== 'undefined' && this._condition();
  }

  private checkRenderCondition() {
    effect(
      () => {
        this.viewContainer.clear(); // Clear view by default
        if (!this.authApi.isAuthorized()) {
          return;
        }

        this.profileApi.user$.pipe(untilDestroyed(this)).subscribe((user) => {
          if (this.roles().includes(user?.role as Role) || this.isAdditionalConditionSet) {
            this.viewContainer.createEmbeddedView(this.templateRef).markForCheck(); // Render template if authorized
          } else {
            this.viewContainer.clear(); // Clear view if role doesn't match
          }
        });
      },
      { allowSignalWrites: true }
    );
  }
}
